import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { KingNewService } from '../../king-new.service';
@Component({
  selector: 'app-king-timer',
  templateUrl: './king-timer.component.html',
  styleUrls: ['./king-timer.component.scss'],
  imports: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingTimerComponent {
  public readonly kingService = inject(KingNewService);
}
